<!--  -->
<template>
	<div class="container">
		<div class="search-container flex flex-between" ref="tableHeight">
			<div class="flex flex-wrap">
				<el-input
					v-model.trim="searchFrom.routeName"
					class="w190 mb5"
					size="small"
					placeholder="路线名称"
					@keyup.enter.native="handleSearch"
					maxlength="20"
					clearable></el-input>
				<el-input
					v-model.trim="searchFrom.routeCode"
					class="w190 ml10"
					size="small"
					placeholder="路线编号"
					@keyup.enter.native="handleSearch"
					maxlength="32"
					clearable></el-input>
				<el-input
					v-model.trim="searchFrom.licensePlate"
					class="w190 ml10"
					size="small"
					placeholder="车辆"
					@keyup.enter.native="handleSearch"
					maxlength="11"
					clearable></el-input>

				<el-select v-model="searchFrom.routeStatus" class="w190 ml10" size="small" placeholder="状态" clearable @change="handleSearch()">
					<el-option label="正常" value="Y"></el-option>
					<el-option label="停用" value="N"></el-option>
				</el-select>
				<el-select v-model="searchFrom.deliveryCycle" class="w190 ml10" size="small" placeholder="请选择配送周期" @change="handleSearch()" clearable>
					<el-option v-for="item in weeklist" :key="item.value" :label="item.label" :value="item.value"></el-option>
				</el-select>

				<img class="icon-img ml10" src="@/assets/images/search.png" @click="handleSearch()" alt="" />
				<el-button plain class="ml10 attr" size="small" @click="handleAttr" v-if="isEdit" :disabled="multipleSelection.length > 0 ? false : true">
					批量调整路线员
				</el-button>
			</div>
			<div class="operation-box" v-if="isEdit">
				<img class="icon-img ml7" src="@/assets/images/merge.png" @click="handleMerge" title="合并" alt="" />
				<img class="icon-img ml7" src="@/assets/images/disable.png" @click="updateStatusRow('N')" title="停用" alt="" />
				<img class="icon-img ml7" src="@/assets/images/enable.png" @click="updateStatusRow('Y')" title="启用" alt="" />
				<img class="icon-img ml7" src="@/assets/images/delete.png" @click="deleteRow" title="删除" alt="" />
				<img class="icon-img ml7" src="@/assets/images/add.png" @click="handleEdit" title="新增" alt="" />
			</div>
		</div>
		<div class="table-container">
			<div v-if="tableData.length > 0">
				<el-table
					class="mgrTable"
					ref="multipleTable"
					v-el-table-infinite-scroll="tableLoad"
					:infinite-scroll-distance="50"
					:infinite-scroll-immediate="false"
					:data="tableData"
					:height="height"
					:cell-style="cellStyle"
					:row-class-name="tabRowClassName"
					:header-cell-style="{
						background: 'rgba(200, 204, 215,.6)',
						color: '#333333',
					}"
					:row-key="
						(row) => {
							return row.dataKey;
						}
					"
					@selection-change="handleSelectionChange"
					border
					style="width: 100%"
					@cell-click="editRow">
					<el-table-column type="selection" width="50" :reserve-selection="true" align="center"></el-table-column>
					<el-table-column
						v-show="tableData"
						v-for="(value, index) in titles"
						:key="index"
						:prop="value.prop"
						sortable
						:column-key="value.prop"
						:fixed="value.fix"
						:show-overflow-tooltip="true"
						:label="value.title"
						:min-width="value.maxWidth">
						<template slot-scope="scope">
							{{ scope.row[value.prop] }}
						</template>
					</el-table-column>
				</el-table>
			</div>
			<el-empty v-else :style="{ height: height + 'px' }" description="暂无数据"></el-empty>
			<div class="flex flex-between search-container">
				<div class="totalPage">
					当前第
					<span class="page-active">{{ currentNo }}</span>
					页，共
					<span class="page-active">{{ totalCount }}</span>
					条数据，共
					<span class="page-active">{{ totalPage }}</span>
					页
				</div>
				<div class="flex">
					<img class="icon-img" style="vertical-align: middle" src="@/assets/images/down.png" @click="download" title="导出" alt="" />
					<el-upload
						v-if="isEdit"
						class="avatar-uploader ml10"
						:action="$api['routeImport'].url"
						:show-file-list="false"
						:before-upload="beforeAvatarUpload">
						<img class="icon-img" style="vertical-align: middle" src="@/assets/images/import.png" title="导入" alt="" />
					</el-upload>

					<img class="icon-img ml10" style="vertical-align: middle" src="@/assets/images/downUrl.png" @click="downloadUrl" title="下载模板" alt="" />
				</div>
			</div>
		</div>
		<routeEdit ref="routeEdit" @getList="handleSearch"></routeEdit>
		<mergeMerRoute ref="mergeMerRoute" @getList="handleSearch"></mergeMerRoute>
		<batch ref="batch" @getList="handleSearch"></batch>
	</div>
</template>

<script>
import routeEdit from "./components/route-edit.vue";
import mergeMerRoute from "./components/merge-route.vue";
import { hasPermission } from "@/utils/permission";
import batch from "./components/batch.vue";
import { debounce } from "@/utils/debounce";
export default {
	name: "route",
	components: {
		routeEdit,
		mergeMerRoute,
		batch,
	},
	data() {
		return {
			searchFrom: {
				deliveryCycle: "",
				licensePlate: "",
				routeCode: "",
				routeName: "",
				routeStatus: "",
			},
			tableData: [],
			titles: [],
			treeData: [],
			multipleSelection: [],
			weeklist: [
				{
					value: "1",
					label: "周一",
				},
				{
					value: "2",
					label: "周二",
				},
				{
					value: "3",
					label: "周三",
				},
				{
					value: "4",
					label: "周四",
				},
				{
					value: "5",
					label: "周五",
				},
				{
					value: "6",
					label: "周六",
				},
				{
					value: "0",
					label: "周日",
				},
				{
					value: "9",
					label: "新路线",
				},
			],
			value: "",
			selectAttribute: "",
			pageNo: 1,
			pageSize: 40,
			height: 500,
			titles: [],
			infiniteFlag: false,
			isEdit: false,
			file: null,
			totalPage: "",
			totalCount: "",
			currentNo: "",
		};
	},
	created() {
		this.getList();
		if (this.$route.meta.perm) {
			this.isEdit = hasPermission(this.$route.meta.perm);
			// console.log(this.isEdit)
		}
	},
	mounted() {
		let height = this.$refs.tableHeight.offsetHeight;
		this.height = window.innerHeight - 126 - height;
	},
	methods: {
		tabRowClassName({ row, rowIndex }) {
			let index = rowIndex + 1;
			if (index % 2 == 1) {
				return "warning-row";
			}
		},
		cellStyle({ row, column, rowIndex, columnIndex }) {
			if (columnIndex == 1) {
				return "cursor: pointer;";
			}
		},
		// 表格滚动加载
		tableLoad: debounce(
			function () {
				this.pageNo++;
				this.getList("scroll");
			},
			100,
			true,
		),
		// 新增
		handleEdit() {
			this.$refs.routeEdit.init();
		},
		handleAttr() {
			this.$refs.batch.init(this.multipleSelection);
		},
		// 合并路线
		handleMerge() {
			this.$refs.mergeMerRoute.init();
		},
		// 查看/编辑
		editRow(row, column, cell, event) {
			if (column.label == "路线名称") {
				this.$refs.routeEdit.init(row);
			} else {
				this.$refs.multipleTable.toggleRowSelection(row);
			}
		},
		handleSearch() {
			if (this.tableData.length > 0) {
				this.$refs.multipleTable.clearSelection();
				this.$refs.multipleTable.bodyWrapper.scrollTop = 0;
			}
			this.infiniteFlag = false;
			this.pageNo = 1;
			this.$nextTick(() => {
				this.getList();
			});
		},
		// 获取列表
		getList(type) {
			if (this.infiniteFlag) {
				return;
			}
			let that = this;
			that.$request
				.post("routeVlistPage", true, {
					pageNo: that.pageNo,
					pageSize: that.pageSize,
					deliveryCycle: that.searchFrom.deliveryCycle,
					licensePlate: that.searchFrom.licensePlate,
					routeCode: that.searchFrom.routeCode,
					routeName: that.searchFrom.routeName,
					routeStatus: that.searchFrom.routeStatus,
				})
				.then((res) => {
					if (res.data) {
						that.infiniteFlag = res.data.totalPage <= that.pageNo;
					}
					if (type == "scroll") {
						that.tableData = that.tableData.concat((res.data && res.data.tableDatas) || []);
						that.totalPage = res.data.totalPage;
						that.totalCount = res.data.totalCount;
						that.currentNo = res.data.pageNo;
					} else {
						if (res.data && res.data.tableDatas.length > 0) {
							that.titles = res.data.titles;
							that.tableData = res.data.tableDatas;
							that.totalPage = res.data.totalPage;
							that.totalCount = res.data.totalCount;
							that.currentNo = res.data.pageNo;
						} else {
							that.titles = [];
							that.tableData = [];
							that.totalPage = 0;
							that.totalCount = 0;
							that.currentNo = 0;
						}
					}
					that.titles = that.titles.map((item, index) => {
						return {
							title: item.title,
							prop: "tr" + index,
							maxWidth: item.maxWidth,
							fix: item.fix == 1 ? true : false,
						};
					});
					that.tableData.forEach((item) => {
						for (let i = 0; i < that.titles.length; i++) {
							item["tr" + i] = item.datas[i] || "";
						}
					});
				});
		},

		// 状态
		updateStatusRow(status) {
			let that = this;
			let msg = "确认要" + (status == "Y" ? "启用" : "停用") + "选中的路线吗？";
			that.$confirm(msg, {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
			})
				.then(() => {
					if (that.multipleSelection.length <= 0) {
						that.$message.error("请先选择!");
						return;
					}
					let userIds = [];
					that.multipleSelection.forEach((item) => {
						userIds.push(item.dataKey);
					});
					that.$request
						.post("routeUpdateStatus", true, {
							routeIds: userIds,
							routeStatus: status,
						})
						.then((res) => {
							if (res) {
								// 0:正常;1:停用
								that.$message.success(status == "Y" ? "已启用！" : "已停用！");
								that.handleSearch();
							}
						});
				})
				.catch(() => {});
		},
		// 列多选
		handleSelectionChange(val) {
			this.multipleSelection = val;
		},
		// 删除
		deleteRow() {
			let that = this;
			if (that.multipleSelection.length <= 0) {
				this.$message.error("请先选择!");
				return;
			}
			let userIds = [];
			that.multipleSelection.forEach((item) => {
				userIds.push(item.dataKey);
			});
			that.$confirm("是否确认删除？", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "error",
			})
				.then(() => {
					that.$request
						.post("routeDelete", false, {
							routeIds: userIds,
						})
						.then((res) => {
							if (res) {
								that.$refs.multipleTable.clearSelection();
								that.$message.success("删除成功！");
								that.handleSearch();
							}
						});
				})
				.catch(() => {});
		},
		// 导出
		download() {
			let that = this;
			// if (that.multipleSelection.length <= 0) {
			// 	this.$message.error('请先选择!');
			// 	return
			// }
			let routeIds = [];
			that.multipleSelection.forEach((item) => {
				routeIds.push(item.dataKey);
			});
			that.$request
				.post("routeExport", true, {
					pageNo: 1,
					pageSize: 50000,
					routeIds: routeIds,
					deliveryCycle: that.searchFrom.deliveryCycle,
					licensePlate: that.searchFrom.licensePlate,
					routeCode: that.searchFrom.routeCode,
					routeName: that.searchFrom.routeName,
					routeStatus: that.searchFrom.routeStatus,
				})
				.then((res) => {
					if (res) {
						let downloadURL = res.data;
						const linkNode = document.createElement("a");
						linkNode.style.display = "none";
						linkNode.href = downloadURL;
						document.body.appendChild(linkNode);
						linkNode.click(); //模拟在按钮上的一次鼠标单击
						URL.revokeObjectURL(linkNode.href); // 释放URL 对象
						document.body.removeChild(linkNode);
					}
				});
		},
		//导入
		importTable(file) {
			let that = this;
			let formdata = new FormData();
			formdata.append("file", file);
			that.$request.formData("routeImport", true, formdata).then((res) => {
				if (res.data.length > 0) {
					let arr = res.data;
					let html = '<div style="height:350px;overflow: auto;">';
					for (let index = 0; index < arr.length; index++) {
						html += "<p>" + arr[index] + "</p>";
					}
					html += "</div>";
					that.$confirm(html, "提示", {
						dangerouslyUseHTMLString: true,
						showCancelButton: false,
						showConfirmButton: false,
						customClass: "customClass",
					})
						.then(() => {})
						.catch(() => {
							that.handleSearch();
						});
				}
			});
		},
		//导入模板
		downloadUrl() {
			let downloadURL = "https://msslx.yakult.com.cn/files/download/template/route_template.xlsx";
			const linkNode = document.createElement("a");
			linkNode.style.display = "none";
			linkNode.href = downloadURL;
			document.body.appendChild(linkNode);
			linkNode.click(); //模拟在按钮上的一次鼠标单击
			URL.revokeObjectURL(linkNode.href); // 释放URL 对象
			document.body.removeChild(linkNode);
		},
		beforeAvatarUpload(file) {
			if (file) {
				if (!["xls", "xlsx"].includes(file.name.split(".").reverse()[0])) {
					this.$message.error("只支持excel格式的文件上传！");
					return;
				}
				if (1024 * 1024 * 2 < file.size) {
					this.$message.error("只支持上传2M以内的文件，请调整文件分批导入！");
					return;
				}
				this.importTable(file);
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.container {
	background: #fff;
	box-sizing: border-box;
	margin: 12px 26px 15px 10px;
	// padding-bottom: 20px;

	.el-table {
		// 深度选择器，去除默认的padding
		/deep/ th {
			padding: 0px;
		}

		/deep/ td {
			padding: 5px;
		}

		/deep/ .warning-row {
			background: #f1f1f5;
		}
		/deep/ th .el-table__cell {
			padding: 0 !important;
		}
	}
}

.red {
	width: 50px;
	height: 20px;
	background: #d9001b;
}

.blue {
	width: 50px;
	height: 20px;
	background: #02a7f0;
}

.search-container {
	padding: 8px;
}

.operation-box {
	min-width: 185px;
}

.w190 {
	width: 140px !important;
}
.attr {
	height: 32px;
	// line-height: 32px;
	border-radius: 4px;
}
</style>
<style>
.customClass {
	width: 550px !important;
}
</style>
